import React, { useContext, useEffect, useState } from "react";
import "../../../../App.css";
import closeSvg from "../../../../assets/closeSvg";
import { AppContext } from "../../../../AppContext";
import { logActivity, sendTextNotification } from "../../../utils";

const GeneratePreApprovalModal = () => {
  const {
    generatePreApprovalModal,
    setGeneratePreApprovalModal,
    userEmail,
    userName,
    userPhone,
    userType,
    makeKey,
    inputPreApprovalNames,
    setInputPreApprovalNames,
    userCompany,
  } = useContext(AppContext);

  const [inputAddress, setInputAddress] = useState("");
  const [inputPreApprovalAmt, setInputPreApprovalAmt] = useState("");
  const [modalInputWarning, setModalInputWarning] = useState(
    "ModalInputWarning hidden"
  );
  const [loadingState, setLoadingState] = useState(false);
  const [modalProgress, setModalProgress] = useState("generate");
  //generate,loading,download
  const [preapprovalPdfLink, setPreapprovalPdfLink] = useState("");
  const [newPreapprovalModal, setNewPreapprovalModal] = useState("hidden");
  const visibility = generatePreApprovalModal["status"];
  const clientName = generatePreApprovalModal["clientName"];
  const preApprovalAmt = generatePreApprovalModal["preApprovalAmount"];
  const loanOfficerName = generatePreApprovalModal["loanOfficerName"];
  const loanOfficerEmail = generatePreApprovalModal["loanOfficerEmail"];
  const agentPartner = generatePreApprovalModal["agentPartner"];
  const agentEmail = generatePreApprovalModal["agentEmail"];
  const downpaymentPercentage =
    generatePreApprovalModal["downpaymentPercentage"];
  const downpaymentDollar = generatePreApprovalModal["downpaymentDollar"];
  const loanProgram = generatePreApprovalModal["loanProgram"];
  const googleTemplateID = generatePreApprovalModal["googleTemplateID"];
  const googleFolderId = generatePreApprovalModal["googleFolderId"];
  const preApprovalNames = generatePreApprovalModal["preApprovalNames"];
  const loanOfficerPhone = generatePreApprovalModal["loanOfficerPhone"]
    ? generatePreApprovalModal["loanOfficerPhone"].replace(/[^0-9.]+/g, "")
    : null;
  const agentPhone = generatePreApprovalModal["agentPhone"]
    ? generatePreApprovalModal["agentPhone"].replace(/[^0-9.]+/g, "")
    : null;
  const coAgentPhone = generatePreApprovalModal["coAgentPhone"]
    ? generatePreApprovalModal["coAgentPhone"].replace(/[^0-9.]+/g, "")
    : null;
  const loanOfficerTextNotifications =
    generatePreApprovalModal["loanOfficerTextNotifications"];
  const agentTextNotifications =
    generatePreApprovalModal["agentTextNotifications"];
  const coAgentTextNotifications =
    generatePreApprovalModal["coAgentTextNotifications"];

  const phoneNumbersArray =
    typeof coAgentPhone == undefined
      ? [
          {
            phone: loanOfficerPhone,
            notifications: loanOfficerTextNotifications,
          },
          { phone: agentPhone, notifications: agentTextNotifications },
        ]
      : [
          {
            phone: loanOfficerPhone,
            notifications: loanOfficerTextNotifications,
          },
          { phone: agentPhone, notifications: agentTextNotifications },
          { phone: coAgentPhone, notifications: coAgentTextNotifications },
        ];

  const notUserPhoneNumbers = phoneNumbersArray.filter((e) => {
    if (userPhone) {
      return e.phone && e.phone !== userPhone.replace(/[^0-9.]+/g, "");
    } else {
      return e.phone !== null;
    }
  });

  function convertCurrencyToNumber(currency) {
    // Remove any non-digit characters except for decimal separator and minus sign
    if (currency === "TBD") {
      return 0;
    } else if (currency) {
      const sanitizedCurrency = currency.replace(/[^\d.-]/g, "");
      // Convert the sanitized string to a number
      const number = parseFloat(sanitizedCurrency);
      return number;
    }
    return 0;
  }

  function formatCurrency(number) {
    const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${formattedNumber}`;
  }

  const preApprovalMax = convertCurrencyToNumber(preApprovalAmt);

  function generatePreApproval() {
    // setLoadingState(true);
    setModalProgress("loading");
    fetch("https://hook.us1.make.com/win3du68ybeudzsagoarr6m76fi4o8di", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        apiKey: makeKey,
        propertyAddress: inputAddress,
        clientName: clientName,
        preApprovalAmount: inputPreApprovalAmt,
        loanOfficerName: loanOfficerName,
        loanOfficerEmail: loanOfficerEmail,
        agentPartner: agentPartner,
        agentEmail: agentEmail,
        downpaymentPercentage: downpaymentPercentage,
        downpaymentDollar: downpaymentDollar,
        loanProgram: loanProgram,
        googleTemplateID: googleTemplateID,
        googleFolderId: googleFolderId,
        preApprovalNames: inputPreApprovalNames,
        userEmail: userEmail,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setPreapprovalPdfLink(data[0]["downloadPdfLink"]);
        setNewPreapprovalModal("");
        setInputAddress("");
        setInputPreApprovalAmt(0);
        setModalProgress("download");
        logActivity({
          apiKey: makeKey,
          userEmail: userEmail,
          userType: userType,
          tab: "Modal",
          action: "Generated Pre-Approval",
          userCompany: userCompany,
        });
        for (let i = 0; i < notUserPhoneNumbers.length; i++) {
          sendTextNotification({
            textNotificationsAllowed: notUserPhoneNumbers[i].notifications,
            textMessage: `${userName} generated a pre-approval letter for ${clientName}. The letter was sent to your email.`,
            textPhone: notUserPhoneNumbers[i].phone,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        alert(
          "The letter was unable to generate. Please contact mike@movemortgage.com for assistance."
        );
        setGeneratePreApprovalModal({ status: "inactive" });
        setModalProgress("generate");
        setInputAddress("");
        setInputPreApprovalAmt(0);
      });
  }

  const title = "Generate Pre Approval";
  const description =
    "Complete the form below to generate a Pre Approval letter (PDF).";

  useEffect(() => {
    if (inputPreApprovalAmt > preApprovalMax) {
      setModalInputWarning("ModalInputWarning");
    } else {
      setModalInputWarning("ModalInputWarning hidden");
    }
  }, [inputPreApprovalAmt]);

  const generatePreApprovalForm = (
    <form className="Modal" id="ModalForm">
      <div
        className="Modal-close"
        onClick={() => {
          setGeneratePreApprovalModal({ status: "inactive" });
          setInputAddress("");
          setInputPreApprovalAmt(0);
        }}
      >
        {closeSvg}
      </div>
      <div className="ModalTitle">{title}</div>
      <div className="ModalDescription">{description}</div>
      <div className="ModalInput">
        <label htmlFor="preApprovalNames">Name(s) on Letter:</label>
        {preApprovalNames ? (
          <div className="fieldInput">{preApprovalNames}</div>
        ) : (
          <input
            className="fieldInput user"
            type="text"
            id="preApprovalNames"
            name="preApprovalNames"
            required={true}
            onChange={(e) => {
              setInputPreApprovalNames(e.target.value);
            }}
          ></input>
        )}
      </div>
      <div className="ModalInput">
        <label htmlFor="loanOfficerName">Loan Officer:</label>
        {loanOfficerName ? (
          <div className="fieldInput">{loanOfficerName}</div>
        ) : (
          <input
            className="fieldInput user"
            type="text"
            id="loanOfficerName"
            name="loanOfficerName"
            required={true}
          ></input>
        )}
      </div>
      <div className="ModalInput">
        <label htmlFor="agentPartner">Agent:</label>
        {agentEmail ? (
          <div className="fieldInput">{agentPartner}</div>
        ) : (
          <div className="fieldInput">
            <i>No agent assigned</i>
          </div>
        )}
      </div>
      <div className="ModalInput">
        <label htmlFor="propertyAddress">Property Address:</label>
        <div className="modalInputHelpText">
          The address you put here will be displayed on the Pre Approval letter.
        </div>
        <input
          className="fieldInput user"
          type="text"
          id="propertyAddress"
          name="propertyaddress"
          required={true}
          value={inputAddress}
          onChange={(e) => {
            setInputAddress(e.target.value);
          }}
        ></input>
      </div>
      <div className="ModalInput">
        <label htmlFor="loanProgram">Loan Program:</label>
        <div className="fieldInput">{loanProgram}</div>
      </div>
      <div className="ModalInput">
        <label htmlFor="preApprovalAmount">
          {`Purchase Price (max ${preApprovalAmt})`}:
        </label>
        <div className="modalInputHelpText">
          The purchase price you would like to appear on the Pre Approval
          letter.
        </div>
        <div
          id="ModalInputWarning"
          className={modalInputWarning}
        >{`*Cannot exceed max.`}</div>
        <input
          className="fieldInput user"
          type="number"
          id="preApprovalAmount"
          name="preapprovalamt"
          step={0.01}
          required={true}
          value={inputPreApprovalAmt}
          max={preApprovalMax}
          onChange={(e) => {
            setInputPreApprovalAmt(e.target.value);
          }}
        ></input>
      </div>
      <div className="ModalInput">
        {downpaymentPercentage !== null ? (
          <>
            <label htmlFor="downPayment">
              Downpayment ({downpaymentPercentage}%):
            </label>
            <div className="fieldInput">
              $
              {formatCurrency(
                (downpaymentPercentage * inputPreApprovalAmt * 0.01)
                  .toFixed(0)
                  .toString()
              )}
            </div>
          </>
        ) : (
          <>
            <label htmlFor="downPayment">Downpayment:</label>
            <div className="fieldInput">
              ${formatCurrency(downpaymentDollar.toString())}
            </div>
          </>
        )}
      </div>
      <div className="fullWidth displayGrid">
        <input
          type="submit"
          value="Submit"
          className="submit button"
          onClick={(e) => {
            const checkForm = document.getElementById("ModalForm");
            if (checkForm.checkValidity()) {
              e.preventDefault();
              generatePreApproval(
                inputAddress,
                preApprovalNames,
                formatCurrency(inputPreApprovalAmt),
                loanOfficerName,
                agentPartner
              );
            } else {
            }
          }}
        ></input>
      </div>
    </form>
  );

  const loading = (
    <form className="Modal" id="ModalForm">
      Generating Pre Approval letter & sending to... <br></br>
      <br></br>
      {agentEmail ? (
        <>
          {agentPartner} ({agentEmail.replace(",", ", ")})<br></br>
        </>
      ) : null}
      {loanOfficerName} ({loanOfficerEmail})
    </form>
  );

  const newPreapproval = (
    <div className={`Modal ${newPreapprovalModal}`}>
      <div
        className="Modal-close"
        onClick={() => {
          setNewPreapprovalModal("hidden");
          setGeneratePreApprovalModal({ status: "inactive" });
          setModalProgress("generate");
        }}
      >
        {closeSvg}
      </div>
      <div>
        <div>
          <b>New Pre Approval</b>
        </div>
        Letter sent to:
        <ul>
          {agentEmail ? (
            <>
              {agentPartner} ({agentEmail.replace(",", ", ")})<br></br>
            </>
          ) : null}
          {loanOfficerName} ({loanOfficerEmail})
        </ul>
        <div className="button-container">
          <a
            className="button clickToDownload"
            href={preapprovalPdfLink}
            rel="noopener noreferrer"
            onClick={() => {
              logActivity({
                apiKey: makeKey,
                userEmail: userEmail,
                userType: userType,
                tab: "Modal",
                action: "Click to Download Button",
                userCompany: userCompany,
              });
            }}
          >
            Click here to download
          </a>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`ModalPage ${visibility} two`}>
      <div className="Modal-background"></div>
      <div className="Modal-container">
        {modalProgress == "generate"
          ? generatePreApprovalForm
          : modalProgress == "loading"
          ? loading
          : newPreapproval}
      </div>
    </div>
  );
};

export default GeneratePreApprovalModal;
